import RegulationLink from './RegulationLink';

export default RegulationLink;
